import { render, staticRenderFns } from "./OaoSessionExpired.vue?vue&type=template&id=054c8944&scoped=true"
import script from "./OaoSessionExpired.vue?vue&type=script&lang=js"
export * from "./OaoSessionExpired.vue?vue&type=script&lang=js"
import style0 from "./OaoSessionExpired.vue?vue&type=style&index=0&id=054c8944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0d1d51ab4c56f75a7402f3cb98fb63e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054c8944",
  null
  
)

export default component.exports